import {Component, Input, OnInit} from '@angular/core';
import {OrderStatuses} from '../../_constants/order-statuses';
import {multiplyCurrency} from '../../_utils/currency-math';

@Component({
    selector: 'bb-display-modifiers',
    templateUrl: './display-modifiers.component.html',
    styleUrls: ['./display-modifiers.component.scss'],
})
export class DisplayModifiersComponent implements OnInit {
    @Input() groupedModifiers: any[];
    @Input() toppingGroupName: string;
    @Input() count: number;
    @Input() hideTotal: boolean;
    @Input() removePadding: boolean;
    @Input() orderStatus: string;
    @Input() parentStyle: string;
    @Input() childStyle: string;

    protected readonly orderStatuses = OrderStatuses;

    constructor() {
    }

    ngOnInit() {
    }

    adjustedPrice(price) {
        return !!this.count ? multiplyCurrency(price, this.count) : price;
    }
}
